import { Carousel } from "antd";

function BannerHomeMobile({ data = [] }) {
	const handleClickBanner = (data) => {
		if (data.href && data.href !== ".") {
      window.location.href = data.href;
    };
    return;
	}
	return (
		<div className="banner-mobile">
			<div className="banner-mobile-box-slide">
				<Carousel 
          autoplaySpeed={5000} 
          autoplay={true} 
          infinite={true}>
					{data.map((it, index) => {
						return (
							<a href={it.href && it.href !== "." ? it.href : null} key={`banner_link_${it.id}_${index}`}>
								<div
									key={`banner_item_${it.id}_${index}`}
									className="banner-mobile-box-slide-item"
									style={{ backgroundImage: `url(${it.path ?? it.image_path})` }}
								/>
							</a>
						);
					})}
				</Carousel>
			</div>
		</div>
	);
}

export default BannerHomeMobile;
